import { render, staticRenderFns } from "./LeaderboardLockedPlayerListComponent.vue?vue&type=template&id=29b55b79&scoped=true&"
import script from "./LeaderboardLockedPlayerListComponent.vue?vue&type=script&lang=ts&"
export * from "./LeaderboardLockedPlayerListComponent.vue?vue&type=script&lang=ts&"
import style0 from "./LeaderboardLockedPlayerListComponent.vue?vue&type=style&index=0&id=29b55b79&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b55b79",
  null
  
)

export default component.exports